export default __webpack_public_path__ + "static/media/defaultplaceholder_dark.3ae4b503.svg";